import { Flex, Avatar, Box, Text, Icon } from '@chakra-ui/react';
import { NotificationCard } from '../components/Card';
import { NotificationTime } from '../components/Time';
import IntroAccepted from '@/assets/icons/notification/IntroAccepted';
import { decode } from 'js-base64';
import { NotificationLink } from '../components/NotificationLink';

export const IntroMade = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));

  return (
    <NotificationCard notification={notification}>
      <Flex>
        <Box>
          <Box height="40px" pos="relative">
            <Avatar
              width="36px"
              height="36px"
              borderRadius="8px"
              className="avatar-md"
              name={data?.requestee_name}
              src={data?.contact_url}
            />
            <Box pos="absolute" bottom="-24px" left="9px">
              <Icon as={IntroAccepted} width="40px" height="40px" />
            </Box>
          </Box>
        </Box>
        <Box ml="12px">
          <Text>
            <Text as="span" pr="4px" fontWeight="semiBold">
              {data.requestee_name}
            </Text>
            have made an intro to
            <NotificationLink
              to={`/candidates/${data.contact_id}`}
              label={data.candidate_name}
              onClose={onClose}
              notification={notification}
              data-test-id="candidate-link"
            />
          </Text>
          <NotificationTime notification={notification} />
        </Box>
      </Flex>
    </NotificationCard>
  );
};
